import { selectErroriCarrelloByTicket, selectTipo } from 'features/carrello/carrelloSelectors';
import { useAppDispatch, useTypedSelector } from 'lib/centralStore';
import { useEffect } from 'react';
import { showErroriOnImportoUpdated, updateMoltiplicatore } from './actions';

import { CarrelloActionScommetti } from 'features/carrello/carrelloActionScommetti';
import { CarrelloInputImporto } from 'features/carrello/carrelloInputImporto';
import { TicketErrore } from 'features/carrello/types';
import styles from './IppicaTicketTotalizzatoreMoltiplicatore.module.scss';
import { useIsDivisible } from './hooks';

export const IppicaTicketTotalizzatoreMoltiplicatore = () => {
  const dispatch = useAppDispatch();
  const moltiplicatore = useTypedSelector((state) => state.ippicaTicket.moltiplicatore);
  const carrelloType = useTypedSelector(selectTipo);
  const erroriCarrello = useTypedSelector((state) => selectErroriCarrelloByTicket(state, carrelloType));

  const isDivisible = useIsDivisible(moltiplicatore!);

  useEffect(() => {
    if (isDivisible && moltiplicatore) {
      dispatch(updateMoltiplicatore(moltiplicatore));
    } else {
      dispatch(showErroriOnImportoUpdated('erroriCarrello', TicketErrore.IncrementoImportoSingolaMultiplaNonCorretto));
    }
  }, [dispatch, isDivisible, moltiplicatore]);

  return (
    <div className={`${styles.container} ${styles.hasPadding} ${styles.hasOnlyHorizontalPadding}`}>
      <CarrelloInputImporto
        hasBtn={true}
        puntata={moltiplicatore!}
        hasCurrency={false}
        erroriCarrello={erroriCarrello}
        setPuntataInputValue={(value) => {
          const newValue = typeof value === 'number' ? value : undefined;
          dispatch(updateMoltiplicatore(newValue!));
        }}
      />
      <CarrelloActionScommetti btnClassName={styles.button} />
    </div>
  );
};
